<template>
  <div
    class="w-full"
  >
    <div
      v-if="isSelecting"
      style="backdrop-filter: blur(2px);"
      class="absolute w-full h-full inset-0 z-10 bg-gray-500 bg-opacity-50"
      @click="isSelecting=false"
    />
    <div
      class="flex justify-begin px-2 py-4 bg-gray-100 cursor-pointer"
      @click="isSelecting=true"
    >
      <eva-icon
        class="mr-2"
        name="funnel-outline"
        fill="#6C63FF"
      />
      <div v-if="Object.keys(selectedTags).length === 0">
        Sin etiquetas
      </div>
      <div v-if="allSelected">
        <span
          class="bg-blue-500 text-white p-2 rounded pointer-events-none"
          @click="isSelecting=true"
        >
          #Todas las etiquetas
        </span>
      </div>
      <div v-else>
        <span
          v-for="tagID in Object.keys(selectedTags)"
          :key="tagID"
          class="bg-gray-300 text-purple-500 p-2 mx-1 rounded pointer-events-none"
          @click="isSelecting=true"
        >
          #{{ selectedTags[tagID] }}
        </span>
      </div>
    </div>
    <div
      v-if="isSelecting"
      class="absolute w-full sm:w-1/2 pb-4 bg-white z-20 rounded shadow-lg"
    >
      <div
        class="block text-center my-0 px-0 relative rounded-md"
      >
        <eva-icon
          class="absolute left-0 my-2 mx-2"
          name="search-outline"
          fill="#282A43"
        />
        <input
          class="w-full h-10 pl-10 text-purple-500 border-2 border-purple-500 border-opacity-0 focus:border-opacity-100"
          type="text"
          placeholder="Buscar etiqueta"
          :value="searchValue"
          @input="searchValue = $event.target.value"
        >
      </div>
      <div
        class="results p-4 overflow-y-auto"
        style="max-height:320px"
      >
        <div v-if="filteredTagIDs.length">
          <div
            class="flex  justify-between p-4 my-2 bg-gray-100 cursor-pointer"
            @click="emptyTags()"
          >
            <eva-icon
              name="checkmark-outline"
              :fill="Object.keys(selectedTags).length === 0 ? '#6C63FF' : '#F7FAFC'"
            />
            <div>
              Ninguna
            </div>
          </div>
          <div
            v-for="tagID in filteredTagIDs"
            :key="tagID"
            class="flex justify-between p-4 my-2 shadow cursor-pointer"
            @click="toggleTag(tagID)"
          >
            <eva-icon
              name="checkmark-outline"
              :fill="Object.keys(selectedTags).indexOf(tagID) >= 0 ? '#6C63FF' : '#F7FAFC'"
            />
            <div class="text-purple-500">
              #{{ tags[tagID] }}
            </div>
          </div>
        </div>
        <div
          v-else
          class="text-center"
        >
          <img
            class="mx-auto w-3/6 opacity-50"
            src="@/assets/empty.svg"
            alt="Empty"
          >
          <div class="mt-4 text-lg text-center">
            ¡Vaya! Parece que no encontramos esa etiqueta.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: { type: Object, default: () => {} },
    unique: { type: Boolean, default: false },
  },
  data () {
    return {
      allSelected: false,
      selectedTags: {},
      isSelecting: false,
      searchValue: '',
    }
  },
  computed: {
    filteredTagIDs () {
      let found = []
      for (const tagID in this.tags) {
        if (this.searchValue.trim() === '') {
          found.push(tagID)
        } else if (this.tags[tagID].toLowerCase().includes(this.searchValue.toLowerCase())) {
          found.push(tagID)
        }
      }
      found = found.sort((tagID1, tagID2) => {
        if (this.tags[tagID1] < this.tags[tagID2]) {
          return -1
        }
        if (this.tags[tagID1] > this.tags[tagID2]) {
          return 1
        }
        return 0
      })
      return found
    },
  },
  watch: {
    selectedTags: function (newTags) {
      this.allSelected = Object.keys(newTags).length === Object.keys(this.tags).length
      this.$emit('change', newTags)
    },
    isSelecting: function (val) {
      if (!val) this.searchValue = ''
    },
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleEsc)
  },
  mounted () {
    document.addEventListener('keydown', this.handleEsc)
  },
  methods: {
    handleEsc (event) {
      const { key } = event
      if (key === 'Escape') {
        this.isSelecting = false
      }
    },
    toggleTag (tagID) {
      if (this.unique) {
        this.selectedTags = { [tagID]: this.tags[tagID] }
        this.isSelecting = false
        return
      }
      if (typeof this.selectedTags[tagID] !== 'undefined') {
        this.$delete(this.selectedTags, tagID)
      } else {
        this.$set(this.selectedTags, tagID, this.tags[tagID])
      }
    },
    emptyTags () {
      if (Object.keys(this.selectedTags).length !== 0) {
        this.selectedTags = {}
      }
      this.isSelecting = false
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
.results::-webkit-scrollbar-track{
  margin: 8px;
  background-color: $white;
}

.results::-webkit-scrollbar{
  width: 10px;
  height: 10px;
}
.results::-webkit-scrollbar-thumb
{
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.12);
}
</style>
